// Filtros rápidos client-side para colecciones — lee tags normalizados (medida/potencia/ohms/canales).
// Construye facetas dinámicas desde los data-* de cada card y filtra el grid en vivo (sin recargar).
(function () {
  var root = document.querySelector('[data-cfilter]');
  var grid = document.querySelector('[data-cfilter-grid]');
  if (!root || !grid) return;

  var bar = root.querySelector('[data-cfilter-bar]');
  var clearBtn = root.querySelector('[data-cfilter-clear]');
  var clearBtn2 = document.querySelector('[data-cfilter-clear2]');
  var emptyEl = document.querySelector('[data-cfilter-empty]');
  var countStrong = document.querySelector('.collection-count strong');
  var items = [].slice.call(grid.querySelectorAll('.cfilter-item'));
  if (!items.length) return;

  var totalCount = items.length;

  // Definición de facetas: clave data-*, etiqueta, formateo de valor, orden
  var FACETS = [
    { key: 'medida', label: 'Medida', fmt: function (v) { return /^[\d.]+$/.test(v) ? v + '"' : v; },
      sort: function (a, b) { var na = parseFloat(a), nb = parseFloat(b); if (!isNaN(na) && !isNaN(nb)) return na - nb; return a.localeCompare(b); } },
    { key: 'potencia', label: 'Potencia', fmt: function (v) { return v; },
      order: ['Hasta 100W', '100-300W', '300-600W', '600-1000W', '1000W+'] },
    { key: 'ohms', label: 'Impedancia', fmt: function (v) { return v + 'Ω'; },
      sort: function (a, b) { return parseFloat(a) - parseFloat(b); } },
    { key: 'canales', label: 'Canales', fmt: function (v) { return v + ' ch'; },
      sort: function (a, b) { return parseFloat(a) - parseFloat(b); } }
  ];

  function valsOf(item, key) {
    var raw = item.getAttribute('data-' + key) || '';
    return raw.split('~').map(function (s) { return s.trim(); }).filter(Boolean);
  }

  var active = {}; // {facetKey: Set}

  // Construir facetas disponibles
  var rendered = [];
  FACETS.forEach(function (f) {
    var counts = {};
    items.forEach(function (it) {
      valsOf(it, f.key).forEach(function (v) { counts[v] = (counts[v] || 0) + 1; });
    });
    var values = Object.keys(counts);
    if (values.length < 2) return; // faceta inútil si <2 valores

    // ordenar
    if (f.order) {
      values.sort(function (a, b) {
        var ia = f.order.indexOf(a), ib = f.order.indexOf(b);
        if (ia === -1) ia = 99; if (ib === -1) ib = 99;
        return ia - ib;
      });
    } else if (f.sort) {
      values.sort(f.sort);
    }

    active[f.key] = new Set();

    var group = document.createElement('div');
    group.className = 'cfilter-group';
    var title = document.createElement('div');
    title.className = 'cfilter-group__title';
    title.textContent = f.label;
    group.appendChild(title);
    var opts = document.createElement('div');
    opts.className = 'cfilter-group__opts';

    values.forEach(function (v) {
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'cfilter-chip';
      chip.setAttribute('data-facet', f.key);
      chip.setAttribute('data-value', v);
      var lbl = document.createElement('span');
      lbl.textContent = f.fmt(v);
      chip.appendChild(lbl);
      var cnt = document.createElement('span');
      cnt.className = 'cfilter-chip__count';
      cnt.textContent = counts[v];
      chip.appendChild(cnt);
      chip.addEventListener('click', function () {
        var set = active[f.key];
        if (set.has(v)) { set.delete(v); chip.classList.remove('is-active'); }
        else { set.add(v); chip.classList.add('is-active'); }
        apply();
      });
      opts.appendChild(chip);
    });
    group.appendChild(opts);
    bar.appendChild(group);
    rendered.push(f.key);
  });

  if (!rendered.length) { root.hidden = true; return; }
  root.hidden = false;

  function anyActive() {
    return rendered.some(function (k) { return active[k] && active[k].size > 0; });
  }

  function apply() {
    var visible = 0;
    items.forEach(function (it) {
      var show = true;
      for (var i = 0; i < rendered.length; i++) {
        var k = rendered[i];
        var set = active[k];
        if (set && set.size) {
          var iv = valsOf(it, k);
          var hit = iv.some(function (v) { return set.has(v); });
          if (!hit) { show = false; break; }
        }
      }
      it.classList.toggle('is-hidden', !show);
      if (show) visible++;
    });
    if (countStrong) countStrong.textContent = anyActive() ? visible : totalCount;
    if (emptyEl) emptyEl.hidden = visible !== 0;
    if (clearBtn) clearBtn.hidden = !anyActive();
  }

  function clearAll() {
    rendered.forEach(function (k) { active[k] = new Set(); });
    bar.querySelectorAll('.cfilter-chip.is-active').forEach(function (c) { c.classList.remove('is-active'); });
    apply();
  }

  if (clearBtn) clearBtn.addEventListener('click', clearAll);
  if (clearBtn2) clearBtn2.addEventListener('click', clearAll);
})();
